/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: G6S77b28YOuh

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { RawUl } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawList/Ul"; // plasmic-import: MgrwvgDVmmr8/codeComponent
import { RawLi } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawList/Li"; // plasmic-import: AzSSlTj_Nw6K/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicAccessibilityStatementBanner.module.css"; // plasmic-import: G6S77b28YOuh/css

createPlasmicElementProxy;

export type PlasmicAccessibilityStatementBanner__VariantMembers = {};
export type PlasmicAccessibilityStatementBanner__VariantsArgs = {};
type VariantPropType = keyof PlasmicAccessibilityStatementBanner__VariantsArgs;
export const PlasmicAccessibilityStatementBanner__VariantProps =
  new Array<VariantPropType>();

export type PlasmicAccessibilityStatementBanner__ArgsType = {
  bulletPoints?: any;
};
type ArgPropType = keyof PlasmicAccessibilityStatementBanner__ArgsType;
export const PlasmicAccessibilityStatementBanner__ArgProps =
  new Array<ArgPropType>("bulletPoints");

export type PlasmicAccessibilityStatementBanner__OverridesType = {
  accessibilityStatement?: Flex__<"section">;
  wrapper?: Flex__<"div">;
  line?: Flex__<typeof PlasmicImg__>;
  title?: Flex__<"h1">;
  row?: Flex__<"div">;
  col?: Flex__<"div">;
  section?: Flex__<"div">;
  head?: Flex__<"h2">;
  text?: Flex__<"p">;
  section2?: Flex__<"div">;
  head2?: Flex__<"h2">;
  text2?: Flex__<"p">;
  rawUl?: Flex__<typeof RawUl>;
  rawLi?: Flex__<typeof RawLi>;
  p?: Flex__<"p">;
  section3?: Flex__<"div">;
  head3?: Flex__<"h2">;
  text3?: Flex__<"p">;
  section4?: Flex__<"div">;
  head4?: Flex__<"h2">;
  text4?: Flex__<"p">;
  section5?: Flex__<"div">;
  head5?: Flex__<"h2">;
  text5?: Flex__<"p">;
  section6?: Flex__<"div">;
  head6?: Flex__<"h2">;
  text6?: Flex__<"p">;
  section7?: Flex__<"div">;
  head7?: Flex__<"h2">;
  text7?: Flex__<"p">;
  text10?: Flex__<"p">;
  link?: Flex__<"a"> & Partial<LinkProps>;
  section8?: Flex__<"div">;
  head8?: Flex__<"h2">;
  text8?: Flex__<"p">;
  section9?: Flex__<"div">;
  head9?: Flex__<"h2">;
  text9?: Flex__<"p">;
};

export interface DefaultAccessibilityStatementBannerProps {
  bulletPoints?: any;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicAccessibilityStatementBanner__RenderFunc(props: {
  variants: PlasmicAccessibilityStatementBanner__VariantsArgs;
  args: PlasmicAccessibilityStatementBanner__ArgsType;
  overrides: PlasmicAccessibilityStatementBanner__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          bulletPoints: {
            measures: [
              "Continually training our staff on accessibility best practices.",
              "Monitoring our website regularly to ensure all content is accessible.",
              "Engaging with users to gather feedback and ensure their needs are met.",
              "Providing enhancements to promote accessibility."
            ]
          }
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"accessibilityStatement"}
      data-plasmic-override={overrides.accessibilityStatement}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.accessibilityStatement
      )}
    >
      <div
        data-plasmic-name={"wrapper"}
        data-plasmic-override={overrides.wrapper}
        className={classNames("all", sty.wrapper)}
      >
        {(
          hasVariant(globalVariants, "mobile", "mobile")
            ? false
            : hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? true
              : true
        ) ? (
          <PlasmicImg__
            data-plasmic-name={"line"}
            data-plasmic-override={overrides.line}
            alt={""}
            className={classNames(sty.line)}
            displayHeight={"1067.99px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={
              hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? "895.01px"
                : "auto"
            }
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/f8c2846a1d939511f6aa136587f7afe2.svg",
              fullWidth: 895,
              fullHeight: 1068,
              aspectRatio: 0.838015
            }}
          />
        ) : null}
        <h1
          data-plasmic-name={"title"}
          data-plasmic-override={overrides.title}
          className={classNames(
            "all",
            "h1",
            "h1__bvRZj",
            "__wab_text",
            sty.title
          )}
        >
          {"Accessibility Statement"}
        </h1>
        <div
          data-plasmic-name={"row"}
          data-plasmic-override={overrides.row}
          className={classNames("all", sty.row)}
        >
          <div
            data-plasmic-name={"col"}
            data-plasmic-override={overrides.col}
            className={classNames("all", sty.col)}
          >
            <div
              data-plasmic-name={"section"}
              data-plasmic-override={overrides.section}
              className={classNames("all", sty.section)}
            >
              <h2
                data-plasmic-name={"head"}
                data-plasmic-override={overrides.head}
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.head
                )}
              >
                {"1. Commitment to Accessibility"}
              </h2>
              <p
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text
                )}
              >
                {
                  "MyEvaluations is committed to ensuring digital accessibility for all users, including those with disabilities. We aim to continually enhance the user experience for everyone and apply the relevant accessibility standards to achieve these goals. We believe in providing an inclusive environment for all users, making our content, features, and services available and functional to as wide an audience as possible."
                }
              </p>
            </div>
            <div
              data-plasmic-name={"section2"}
              data-plasmic-override={overrides.section2}
              className={classNames("all", sty.section2)}
            >
              <h2
                data-plasmic-name={"head2"}
                data-plasmic-override={overrides.head2}
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.head2
                )}
              >
                {"2. Measures to Support Accessibility"}
              </h2>
              <p
                data-plasmic-name={"text2"}
                data-plasmic-override={overrides.text2}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text2
                )}
              >
                {
                  "MyEvaluations takes the following measures to ensure the accessibility of our website and services:"
                }
              </p>
              <RawUl
                data-plasmic-name={"rawUl"}
                data-plasmic-override={overrides.rawUl}
                className={classNames("__wab_instance", sty.rawUl)}
              >
                {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                  (() => {
                    try {
                      return $props.bulletPoints.measures;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()
                ).map((__plasmic_item_0, __plasmic_idx_0) => {
                  const currentItem = __plasmic_item_0;
                  const currentIndex = __plasmic_idx_0;
                  return (
                    <RawLi
                      data-plasmic-name={"rawLi"}
                      data-plasmic-override={overrides.rawLi}
                      className={classNames("__wab_instance", sty.rawLi)}
                      key={currentIndex}
                    >
                      <p
                        data-plasmic-name={"p"}
                        data-plasmic-override={overrides.p}
                        className={classNames(
                          "all",
                          "p",
                          "p__bvRZj",
                          "__wab_text",
                          sty.p
                        )}
                      >
                        <React.Fragment>
                          {(() => {
                            try {
                              return currentItem;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return "";
                              }
                              throw e;
                            }
                          })()}
                        </React.Fragment>
                      </p>
                    </RawLi>
                  );
                })}
              </RawUl>
            </div>
            <div
              data-plasmic-name={"section3"}
              data-plasmic-override={overrides.section3}
              className={classNames("all", sty.section3)}
            >
              <h2
                data-plasmic-name={"head3"}
                data-plasmic-override={overrides.head3}
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.head3
                )}
              >
                {"3. Conformance Status"}
              </h2>
              <p
                data-plasmic-name={"text3"}
                data-plasmic-override={overrides.text3}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text3
                )}
              >
                {
                  "The Web Content Accessibility Guidelines (WCAG) define requirements for designers and developers to improve accessibility for people with disabilities. MyEvaluations aims to conform with WCAG 2.1 level AA standards."
                }
              </p>
            </div>
            <div
              data-plasmic-name={"section4"}
              data-plasmic-override={overrides.section4}
              className={classNames("all", sty.section4)}
            >
              <h2
                data-plasmic-name={"head4"}
                data-plasmic-override={overrides.head4}
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.head4
                )}
              >
                {"4. Compatibility with Browsers \nand Assistive Technology"}
              </h2>
              <p
                data-plasmic-name={"text4"}
                data-plasmic-override={overrides.text4}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text4
                )}
              >
                {
                  "MyEvaluations is designed to be compatible with a range of browsers and assistive technologies including screen readers, magnifiers, and voice recognition software."
                }
              </p>
            </div>
            <div
              data-plasmic-name={"section5"}
              data-plasmic-override={overrides.section5}
              className={classNames("all", sty.section5)}
            >
              <h2
                data-plasmic-name={"head5"}
                data-plasmic-override={overrides.head5}
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.head5
                )}
              >
                {"5. Technical Specifications"}
              </h2>
              <p
                data-plasmic-name={"text5"}
                data-plasmic-override={overrides.text5}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text5
                )}
              >
                {
                  "For optimal performance, it's recommended that users rely on modern, updated browsers and assistive technologies."
                }
              </p>
            </div>
            <div
              data-plasmic-name={"section6"}
              data-plasmic-override={overrides.section6}
              className={classNames("all", sty.section6)}
            >
              <h2
                data-plasmic-name={"head6"}
                data-plasmic-override={overrides.head6}
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.head6
                )}
              >
                {"6. Limitations and Alternatives"}
              </h2>
              <p
                data-plasmic-name={"text6"}
                data-plasmic-override={overrides.text6}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text6
                )}
              >
                {
                  "Despite our best efforts, there might be some sections of the website that do not yet adhere to the highest accessibility standards. such cases, please contact our team for assistance or an alternative method of accessing the information."
                }
              </p>
            </div>
            <div
              data-plasmic-name={"section7"}
              data-plasmic-override={overrides.section7}
              className={classNames("all", sty.section7)}
            >
              <h2
                data-plasmic-name={"head7"}
                data-plasmic-override={overrides.head7}
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.head7
                )}
              >
                {"7. Feedback & Contact"}
              </h2>
              <p
                data-plasmic-name={"text7"}
                data-plasmic-override={overrides.text7}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text7
                )}
              >
                {
                  "Your feedback is invaluable in helping us make our website more accessible."
                }
              </p>
              <p
                data-plasmic-name={"text10"}
                data-plasmic-override={overrides.text10}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text10
                )}
              >
                <React.Fragment>
                  <React.Fragment>
                    {
                      "If you experience any difficulty accessing content on MyEvaluations,or if you have suggestions on how we might improve our accessibility features, please contact us at "
                    }
                  </React.Fragment>
                  {
                    <PlasmicLink__
                      data-plasmic-name={"link"}
                      data-plasmic-override={overrides.link}
                      className={classNames(
                        "all",
                        "a",
                        "a__bvRZj",
                        "__wab_text",
                        "plasmic_default__inline",
                        sty.link
                      )}
                      component={Link}
                      href={"mailto:Sales@MyEvaluations.com"}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"Sales@MyEvaluations.com"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{"."}</React.Fragment>
                </React.Fragment>
              </p>
            </div>
            <div
              data-plasmic-name={"section8"}
              data-plasmic-override={overrides.section8}
              className={classNames("all", sty.section8)}
            >
              <h2
                data-plasmic-name={"head8"}
                data-plasmic-override={overrides.head8}
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.head8
                )}
              >
                {"8. Assessment Approach"}
              </h2>
              <p
                data-plasmic-name={"text8"}
                data-plasmic-override={overrides.text8}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text8
                )}
              >
                {
                  "MyEvaluations regularly conducts accessibility reviews of its website and remediates any issues uncovered by these assessments."
                }
              </p>
            </div>
            <div
              data-plasmic-name={"section9"}
              data-plasmic-override={overrides.section9}
              className={classNames("all", sty.section9)}
            >
              <h2
                data-plasmic-name={"head9"}
                data-plasmic-override={overrides.head9}
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.head9
                )}
              >
                {"9. Formal Approvals"}
              </h2>
              <p
                data-plasmic-name={"text9"}
                data-plasmic-override={overrides.text9}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text9
                )}
              >
                {
                  "This accessibility statement is approved by the executive board and CEO of MyEvaluations.com Inc. and is reviewed periodically to ensure it remains relevant and accurate.\n\nThis statement was created on July 10, 2023."
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  accessibilityStatement: [
    "accessibilityStatement",
    "wrapper",
    "line",
    "title",
    "row",
    "col",
    "section",
    "head",
    "text",
    "section2",
    "head2",
    "text2",
    "rawUl",
    "rawLi",
    "p",
    "section3",
    "head3",
    "text3",
    "section4",
    "head4",
    "text4",
    "section5",
    "head5",
    "text5",
    "section6",
    "head6",
    "text6",
    "section7",
    "head7",
    "text7",
    "text10",
    "link",
    "section8",
    "head8",
    "text8",
    "section9",
    "head9",
    "text9"
  ],
  wrapper: [
    "wrapper",
    "line",
    "title",
    "row",
    "col",
    "section",
    "head",
    "text",
    "section2",
    "head2",
    "text2",
    "rawUl",
    "rawLi",
    "p",
    "section3",
    "head3",
    "text3",
    "section4",
    "head4",
    "text4",
    "section5",
    "head5",
    "text5",
    "section6",
    "head6",
    "text6",
    "section7",
    "head7",
    "text7",
    "text10",
    "link",
    "section8",
    "head8",
    "text8",
    "section9",
    "head9",
    "text9"
  ],
  line: ["line"],
  title: ["title"],
  row: [
    "row",
    "col",
    "section",
    "head",
    "text",
    "section2",
    "head2",
    "text2",
    "rawUl",
    "rawLi",
    "p",
    "section3",
    "head3",
    "text3",
    "section4",
    "head4",
    "text4",
    "section5",
    "head5",
    "text5",
    "section6",
    "head6",
    "text6",
    "section7",
    "head7",
    "text7",
    "text10",
    "link",
    "section8",
    "head8",
    "text8",
    "section9",
    "head9",
    "text9"
  ],
  col: [
    "col",
    "section",
    "head",
    "text",
    "section2",
    "head2",
    "text2",
    "rawUl",
    "rawLi",
    "p",
    "section3",
    "head3",
    "text3",
    "section4",
    "head4",
    "text4",
    "section5",
    "head5",
    "text5",
    "section6",
    "head6",
    "text6",
    "section7",
    "head7",
    "text7",
    "text10",
    "link",
    "section8",
    "head8",
    "text8",
    "section9",
    "head9",
    "text9"
  ],
  section: ["section", "head", "text"],
  head: ["head"],
  text: ["text"],
  section2: ["section2", "head2", "text2", "rawUl", "rawLi", "p"],
  head2: ["head2"],
  text2: ["text2"],
  rawUl: ["rawUl", "rawLi", "p"],
  rawLi: ["rawLi", "p"],
  p: ["p"],
  section3: ["section3", "head3", "text3"],
  head3: ["head3"],
  text3: ["text3"],
  section4: ["section4", "head4", "text4"],
  head4: ["head4"],
  text4: ["text4"],
  section5: ["section5", "head5", "text5"],
  head5: ["head5"],
  text5: ["text5"],
  section6: ["section6", "head6", "text6"],
  head6: ["head6"],
  text6: ["text6"],
  section7: ["section7", "head7", "text7", "text10", "link"],
  head7: ["head7"],
  text7: ["text7"],
  text10: ["text10", "link"],
  link: ["link"],
  section8: ["section8", "head8", "text8"],
  head8: ["head8"],
  text8: ["text8"],
  section9: ["section9", "head9", "text9"],
  head9: ["head9"],
  text9: ["text9"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  accessibilityStatement: "section";
  wrapper: "div";
  line: typeof PlasmicImg__;
  title: "h1";
  row: "div";
  col: "div";
  section: "div";
  head: "h2";
  text: "p";
  section2: "div";
  head2: "h2";
  text2: "p";
  rawUl: typeof RawUl;
  rawLi: typeof RawLi;
  p: "p";
  section3: "div";
  head3: "h2";
  text3: "p";
  section4: "div";
  head4: "h2";
  text4: "p";
  section5: "div";
  head5: "h2";
  text5: "p";
  section6: "div";
  head6: "h2";
  text6: "p";
  section7: "div";
  head7: "h2";
  text7: "p";
  text10: "p";
  link: "a";
  section8: "div";
  head8: "h2";
  text8: "p";
  section9: "div";
  head9: "h2";
  text9: "p";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAccessibilityStatementBanner__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAccessibilityStatementBanner__VariantsArgs;
    args?: PlasmicAccessibilityStatementBanner__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicAccessibilityStatementBanner__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicAccessibilityStatementBanner__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAccessibilityStatementBanner__ArgProps,
          internalVariantPropNames:
            PlasmicAccessibilityStatementBanner__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAccessibilityStatementBanner__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "accessibilityStatement") {
    func.displayName = "PlasmicAccessibilityStatementBanner";
  } else {
    func.displayName = `PlasmicAccessibilityStatementBanner.${nodeName}`;
  }
  return func;
}

export const PlasmicAccessibilityStatementBanner = Object.assign(
  // Top-level PlasmicAccessibilityStatementBanner renders the root element
  makeNodeComponent("accessibilityStatement"),
  {
    // Helper components rendering sub-elements
    wrapper: makeNodeComponent("wrapper"),
    line: makeNodeComponent("line"),
    title: makeNodeComponent("title"),
    row: makeNodeComponent("row"),
    col: makeNodeComponent("col"),
    section: makeNodeComponent("section"),
    head: makeNodeComponent("head"),
    text: makeNodeComponent("text"),
    section2: makeNodeComponent("section2"),
    head2: makeNodeComponent("head2"),
    text2: makeNodeComponent("text2"),
    rawUl: makeNodeComponent("rawUl"),
    rawLi: makeNodeComponent("rawLi"),
    p: makeNodeComponent("p"),
    section3: makeNodeComponent("section3"),
    head3: makeNodeComponent("head3"),
    text3: makeNodeComponent("text3"),
    section4: makeNodeComponent("section4"),
    head4: makeNodeComponent("head4"),
    text4: makeNodeComponent("text4"),
    section5: makeNodeComponent("section5"),
    head5: makeNodeComponent("head5"),
    text5: makeNodeComponent("text5"),
    section6: makeNodeComponent("section6"),
    head6: makeNodeComponent("head6"),
    text6: makeNodeComponent("text6"),
    section7: makeNodeComponent("section7"),
    head7: makeNodeComponent("head7"),
    text7: makeNodeComponent("text7"),
    text10: makeNodeComponent("text10"),
    link: makeNodeComponent("link"),
    section8: makeNodeComponent("section8"),
    head8: makeNodeComponent("head8"),
    text8: makeNodeComponent("text8"),
    section9: makeNodeComponent("section9"),
    head9: makeNodeComponent("head9"),
    text9: makeNodeComponent("text9"),

    // Metadata about props expected for PlasmicAccessibilityStatementBanner
    internalVariantProps: PlasmicAccessibilityStatementBanner__VariantProps,
    internalArgProps: PlasmicAccessibilityStatementBanner__ArgProps
  }
);

export default PlasmicAccessibilityStatementBanner;
/* prettier-ignore-end */
